import {
    Box,
    useTheme,
    Typography,
    Switch,
    Button,
    TextField,
    useMediaQuery,
} from "@mui/material";
import logo from "../../assets/buzz.png";
// import mark from "../../assets/mark.jpg";
import enabledlocation from "../../assets/enabledlocation.svg";
import male from "../../assets/maleinstant.svg";
import { width } from "@mui/system";

import {
    GoogleMap,
    InfoWindow,
    InfoWindowF,
    Marker,
    MarkerF,
    useLoadScript,
} from "@react-google-maps/api";
import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { tokens } from "../../Theme/theme";
import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import { Header } from "../global/Header";
import { Add, AddCircleOutline, AddOutlined, ArrowBackIosNewRounded, ArrowDownwardRounded, ArrowRightAltRounded } from "@mui/icons-material";
import '../Users/MapStyle.css'
import BASE_URL from "../../NetworkConfig/ApiConfig";
import CreateCommunityPopup from "../Utils/CreateCommunityPopup";

const CommunityList = () => {


    return <CommunityListView />;
};
const Convert_Time_Zone = (isostring) => {
    const isoString = isostring;
    const desiredFormat = "dd MMMM yyyy, hh:mm:ss a";

    const indianTimeZone = "Asia/Kolkata";
    const zonedTime = utcToZonedTime(isoString, indianTimeZone);

    const formattedDate = format(zonedTime, desiredFormat, {
        timeZone: indianTimeZone,
    });

    return formattedDate;
};
function CommunityListView({ data }) {
    const [locations, setlocations] = useState(null);
    const [UserLastLocation, setUserLastLocation] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [userProfile, setUserProfile] = useState({})
    const [showCreateCommunityPopup, setShowCreateCommunityPopup] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [hasEnded, setHasEnded] = useState(false)
    const [loading, setLoading] = useState(false)

    const FetchCommunities = async (page) => {

        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/community/getall?page=${page}&limit=${20}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token,
                },
            });
            const data = await response.json();
            if (data.success === true) {
                setCommunities(prev => page == 1 ? data.response : [...prev, ...data.response]);
                setCurrentPage(page)
                if (data?.response?.length < 20) {
                    setHasEnded(true)
                }
                setLoading(false);
            } else {
                setLoading(false)
                alert(data?.response ?? "Something went wrong!")
            }
        } catch (error) {
            setLoading(false)
            console.log(error.replace(`${BASE_URL}/community/getall`, ""))
            alert("Something went wrong!")
        }


    };

    useEffect(() => {
        async function getUserProfile() {
            const profile_obj = localStorage.getItem("profile")
            setUserProfile(JSON.parse(profile_obj))
        }
        getUserProfile()
        FetchCommunities(1);
    }, []);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [communitites, setCommunities] = useState([])

    const isMobileScreen = useMediaQuery('(max-width:500px)');
    const isTabScreen = useMediaQuery('(max-width:1200px)')


    return (
        <>
            <Box m={"20px"} flexDirection={'column'} display={'flex'}>
                <Box
                    display={"flex"}
                    justifyContent="space-between"
                    alignItems={"center"}
                    sx={{ flexWrap: 'wrap', flexDirection: 'row', gap: "10px", marginBottom: isMobileScreen ? "0px" : "20px", marginInline: isMobileScreen ? "0px" : "10px" }}
                >
                    <Header
                        imgInc={true}
                        title={`Communities`}
                        subtitle={`List of available or onboarded communities.`}
                    />


                    {
                        userProfile._id && userProfile.Role == "ADMIN" && (
                            <Box
                                onClick={() => {
                                    setShowCreateCommunityPopup(true)
                                }}
                                sx={{
                                    flexDirection: 'row', alignItems: 'center', display: 'flex', background: "#ffffff10",
                                    borderRadius: "8px", paddingInline: "12px", paddingBlock: "8px", gap: "5px",
                                    border: "0px solid #ffffff40", cursor: 'pointer', marginBottom: isMobileScreen ? "15px" : "0px"
                                }}>
                                <AddOutlined />
                                <Typography color={"#ffffff"}
                                    fontFamily={"poppins-reg"}
                                    fontSize={"14px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >New Community</Typography>

                            </Box>
                        )
                    }


                </Box>
                <Box display={"flex"} flexDirection={'column'} alignSelf={'stretch'} alignItems={'stretch'} pb={"500px"}>

                    <Box
                        display={"grid"}
                        gridTemplateColumns="repeat(12,1fr)"
                        gap="20px"
                        pb={"20px"}
                    >
                        {
                            communitites.map((community) => {
                                return (
                                    <Box
                                        // key={`${transaction.txId}-${i}`}
                                        gridColumn={isMobileScreen ? "span 12" : isTabScreen ? "span 6" : "span 4"}
                                        gridRow="span 2"
                                        display="flex"
                                        alignItems="center"
                                        px="15px"
                                        py={"8px"}
                                        component={Link}
                                        backgroundColor={"#ffffff05"}
                                        borderRadius={"35px"}
                                        to={{
                                            pathname: "/admin/communitydetail",
                                            search: `?community=${community._id}`,
                                            state: { fromDashboard: true },
                                            // console.log(first)
                                        }}

                                        sx={{
                                            textDecoration: 'none', paddingY: "20px", flexDirection: 'row', alignItems: 'center',
                                            display: 'flex',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            <img
                                                alt="profile-user"
                                                width="80px"
                                                height="80px"
                                                src={`${community.logo}`}
                                                style={{
                                                    cursor: "pointer", objectFit: 'cover',
                                                    borderRadius: "50%",
                                                    border: "3px solid #ffffff10"
                                                }}
                                            />
                                        </Box>
                                        <Box sx={{ ml: "20px", mr: "20px", display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                            <Typography color={"#ffffff"}
                                                fontFamily={"poppins-reg"}
                                                fontSize={"15px"} style={{ maxLines: 1, textOverflow: 'ellipsis', }} >{community.title}</Typography>

                                            <Box sx={{
                                                display: 'flex', flexDirection: "row", alignItems: 'center', marginTop: "4px",
                                                gap: "5px"
                                            }}>
                                                <Typography color={community.communityType == "Business" ? "#ff8800" : "#752bffff"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        borderRadius: "100px",
                                                        background: community.communityType == "Business" ? "#ff880010" : "#752bff20",
                                                        paddingTop: "3px",
                                                        paddingBottom: "3px",
                                                        paddingLeft: "12px",
                                                        paddingRight: "12px"
                                                    }}
                                                    fontSize={"12px"}>{community.communityType}</Typography>
                                                <Typography color={"#aaaaaa"}
                                                    fontFamily={"poppins-reg"}
                                                    style={{
                                                        borderRadius: "100px",
                                                        background: "#aaaaaa20",
                                                        paddingTop: "3px",
                                                        paddingBottom: "3px",
                                                        paddingLeft: "12px",
                                                        paddingRight: "12px"
                                                    }}
                                                    fontSize={"12px"}>{community.admins.length} admins</Typography>
                                            </Box>
                                        </Box>

                                        {/* <Box sx={{
                                            height: "1.5px",
                                            background: "#aaaaaa20",
                                            alignSelf: 'stretch',
                                            marginY: "15px"
                                        }} />

                                        <Typography color={"#ffffff90"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"11px"}>Community Mail</Typography>

                                        <Typography color={"#ffffff"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"13px"}>{community.communityMail}</Typography>


                                        <Typography color={"#ffffff90"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            marginTop={"20px"}
                                            fontSize={"11px"}>Date Created</Typography>

                                        <Typography color={"#ffffff"}
                                            alignSelf={'flex-start'}
                                            fontFamily={"poppins-reg"}
                                            fontSize={"13px"}>{Convert_Time_Zone(community.createdAt)}</Typography> */}


                                    </Box>
                                );
                            })}




                    </Box>
                    {
                        hasEnded && !loading && (
                            <Box sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "12px", color: "#ffffff90"
                            }} >- Looks like you have reached to the end -</Box>
                        )
                    }

                    {
                        !hasEnded && !loading && (
                            <Box onClick={() => {
                                if (!hasEnded) {
                                    FetchCommunities(currentPage + 1)
                                }
                            }} sx={{
                                alignSelf: "center", paddingBlock: "8px", paddingInline: "30px", marginBottom: "20px", marginTop: "10px",
                                fontFamily: "poppins-reg", fontSize: "13px", borderRadius: "10px", border: "1px solid #943bff",
                                background: "#943bff20", cursor: "pointer",
                            }} >Load More</Box>
                        )
                    }
                </Box>

                <CreateCommunityPopup
                    open={showCreateCommunityPopup}
                    onClose={() => setShowCreateCommunityPopup(false)}
                    onComplete={() => {
                        setShowCreateCommunityPopup(false)
                        FetchCommunities(1)
                    }}
                />

            </Box>
        </>
    );
}

export default CommunityList;
